// extracted by mini-css-extract-plugin
module.exports = {"element":"accordion-list_element__2Mn7Y"};